document.addEventListener("DOMContentLoaded", () => {
    const toggleButtons = document.querySelectorAll(
      "[data-event='toggle-search']"
    );
  
    const searchModal = document.querySelector(".Search_Drawer");

    console.log("searchModal", searchModal);
  
    toggleButtons.forEach(registerSearchTrigger);
  
    function registerSearchTrigger(trigger) {
      trigger.addEventListener("click", (e) => {
        e.preventDefault();
        publish(PUB_SUB_EVENTS.closeOpenPopup, {
          source: searchModal,
        });
        searchModal.classList.toggle("Open");
      });
    }
  
    subscribe(PUB_SUB_EVENTS.closeOpenPopup, function (data) {
      if (data.source !== searchModal) {
        searchModal.classList.remove("Open");
      }
    });
  
    subscribe(PUB_SUB_EVENTS.contentAdded, function (data) {
      const triggers = data.content.querySelectorAll(
        "[data-event='toggle-search']"
      );
      triggers.forEach(registerSearchTrigger);
    });
  });
  
  class SearchForm extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('input[type="search"]');
  
      if (this.input) {
        this.input.form.addEventListener("reset", this.onFormReset.bind(this));
        this.input.addEventListener(
          "input",
          debounce((event) => {
            this.onChange(event);
          }, 300).bind(this)
        );
  
        if (
          this.input.parentElement.querySelector(".search__input--icon-clear") !=
          null
        ) {
          let clearIcon = this.input.parentElement.querySelector(
            ".search__input--icon-clear"
          );
  
          clearIcon.addEventListener("click", () => {
            this.input.form.reset();
            this.onFormReset();
          });
        }
      }
    }
  
    onFormReset(event) {
      // Prevent default so the form reset doesn't set the value gotten from the url on page load
      if (event) {
        event.preventDefault();
      }
      // Don't reset if the user has selected an element on the predictive search dropdown
      this.input.value = "";
      //this.input.focus();
    }
  }
  
  customElements.define("search-form", SearchForm);
  